<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <div class="page-edit">
      <!--      <form-template ref="formTemplate" @submit="submitData">-->
      <!--      </form-template>-->
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="repetitionName" label="商品名称可以重复：">
            <el-radio-group
              v-model="form.repetitionName"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="automaticCode" label="自动生成自编码：">
            <el-radio-group
              v-model="form.automaticCode"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.automaticCode == 1">
          <el-form-item prop="artNoLength" label="自编码等于当前货号后：">
            <el-select
              class="select-number"
              v-model="form.artNoLength"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in numberList"
                :key="index"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <span>位</span>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="false">
          <el-form-item prop="changeBarCode" label="条码允许修改：">
            <el-radio-group
              v-model="form.changeBarCode"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="goodsAdjustPrice" label="直接在商品档案中调价：">
            <el-radio-group
              v-model="form.goodsAdjustPrice"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="submitData">提交</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
    <br>
    <div class="page-title">助记码生成</div>
    <div class="page-edit">
      <el-form :model="mnemonicCodeForm" ref="mnemonicCodeForm" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="mnemonicCodeUpdateFlag" label="更新范围：">
            <span>第&nbsp;</span>
            <el-select
              v-model="mnemonicCodeForm.mnemonicCodeUpdateStr"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in mnemonicCodeScopeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span>&nbsp;条</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="changeBarCode" label="更新格式：">
            <el-radio-group
              v-model="mnemonicCodeForm.mnemonicCodeFormatFlag"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in formatList"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="mnemonicCodeSubmitData">重新生成助记码</el-button>
      </div>
    </div>
    <br>
    <div class="page-title">商品简称生成</div>
    <div class="page-edit">
      <el-form :model="abbreviateForm" ref="abbreviateForm" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="changeBarCode" label="更新范围：">
            <span>第&nbsp;</span>
            <el-select
              v-model="abbreviateForm.abbreviateUpdateStr"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in abbreviateScopeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span>&nbsp;条</span>
          </el-form-item>
        </el-col>
        <span style="color: #f9a93a">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;说明:  简称将截取商品名称前10个汉字或字符</span>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="abbreviateSubmitData">重新生成简称</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import formTemplate from "@/components/template/formTemplate";
import api from "../../../config/api";
// import api from "@/config/api";

export default {
  components: {
    formTemplate,
  },
  data() {
    return {

      // numberList:['6','7','8'], 范围 mnemonicCodeScope
      // goods_abbreviate 简称
      // mnemonic_code 助记码
      // 助记码范围
      mnemonicCodeScopeList: [],
      // 简称范围
      abbreviateScopeList: [],
      // 助记码格式
      formatList: [
        {label: '品名首字母大写', id: 0},
        {label: '品名首字母小写', id: 1},
      ],
      mnemonicCodeForm: {
        mnemonicCodeUpdateStr: null,
        mnemonicCodeFormatFlag: null,
      },
      // 简称范围
      abbreviateList: [
        {label: '全部重新生成', id: 0},
        {label: '仅生成简称为空的', id: 1},
      ],
      abbreviateForm: {
        abbreviateUpdateStr: null,
      },
      typeList: [
        {label: '启用', id: 1},
        {label: '不启用', id: 0},
      ],
      isDisabled: false,
      form: {
        repetitionName: null,//商品名称是否可以重复
        goodsAdjustPrice: null,//允许在商品档案中调价
        automaticCode: null,  //自编码自动生成
        changeBarCode: null,  //条码允许修改
        artNoLength: 10,      //自编码等于当前货号后
      },
      rules: {},
      title: '',
      dialogVisibility: false,
      // 高级搜索条件
      // addColumns: {
      //   formType: 'other',
      //   labelWidth: "180px",
      //   columns: [
      //     {label: '基础信息', type: 'title', },
      //     {
      //       label: "",
      //       type: "id",
      //     },
      //     {
      //       label: "商品名称可以重复",
      //       type: "radio",
      //       prop: "isRepetitionName",
      //       span: 24,
      //       defaultValue:1,
      //       data:[{label:'启用',id:1},{label:'不启用',id:0},]
      //     },
      //     {
      //       label: "自动生成自编码",
      //       type: "radio",
      //       prop: "isAutomaticCode",
      //       span: 24,
      //       defaultValue:1,
      //       data:[{label:'启用',id:1},{label:'不启用',id:0},]
      //     },
      //     {
      //       label: "自编码等于当前货号后",
      //       type: "select",
      //       prop: "artNoLength",
      //       isShow: false,
      //       defaultValue:10,
      //       data: this.$utils.getCacheStatus("asGoodsDefault.artNoLength"),
      //     },
      //     {
      //       label: "条码允许修改",
      //       type: "radio",
      //       prop: "isChangeBarCode",
      //       span: 24,
      //       defaultValue:0,
      //       data:[{label:'启用',id:1},{label:'不启用',id:0},]
      //     },
      //     {
      //       label: "直接在商品档案中调价",
      //       type: "radio",
      //       prop: "isGoodsAdjustPrice",
      //       span: 24,
      //       defaultValue:1,
      //       // data: this.$utils.getCacheStatus("sysPayMode.status"),
      //       data:[{label:'启用',id:1},{label:'不启用',id:0},]
      //     },
      //   ],
      // }
    };
  },
  computed: {
    numberList() {
      return this.$utils.getCacheStatus("asGoodsDefault.artNoLength")
    },
  },
  created() {
  },
  mounted() {
    this.title = document.title;
    this.getSetDetail();
    this.queryGoodsCountList();
  },
  methods: {
    // 获取设置详情
    getSetDetail() {
      this.$axios.fetchGet(api.archives.asGoodsDefaultDetail, {}).then(data => {
        if (data.code === 200) {
          if (data.data) {
            if (data.data.repetitionName) {
              data.data.repetitionName = 1
            } else {
              data.data.repetitionName = 0
            }

            if (data.data.goodsAdjustPrice) {
              data.data.goodsAdjustPrice = 1
            } else {
              data.data.goodsAdjustPrice = 0
            }

            if (data.data.automaticCode) {
              data.data.automaticCode = 1
            } else {
              data.data.automaticCode = 0
            }

            if (data.data.changeBarCode) {
              data.data.changeBarCode = 1
            } else {
              data.data.changeBarCode = 0
            }
            this.form = data.data;
          }
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      }).catch((err) => {
        this.$message({message: '请求失败', type: 'error'});
      });
    },
    queryGoodsCountList() {
      this.$axios.fetchPost(api.archives.queryGoodsCountList, {}).then(data => {
        if (data.code === 200) {
          this.mnemonicCodeScopeList = data.data;
          this.abbreviateScopeList = data.data;
        }
      }).catch((err) => {
        this.$notify({
          type: "error",
          title: '查询操作',
          message: '失败',
          showClose: false,
        });
      });
    },
    // 重置
    reset() {
      this.getSetDetail()
    },
    submitData() {
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.archives.asGoodsDefault, this.form).then(data => {
        if (data.code === 200) {
          this.getSetDetail();
          this.$notify({
            type: "success",
            title: '保存操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功'});
        } else {
          this.$notify({
            type: "error",
            title: '保存操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: data.errorMsg});
        }
      }).catch((err) => {
        this.$notify({
          type: "error",
          title: '保存操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({message: '请求失败', type: 'error'});
      }).finally(() => {
        loading.close();
      });
    },
    mnemonicCodeSubmitData() {
      if (this.mnemonicCodeForm.mnemonicCodeUpdateStr === '' || this.mnemonicCodeForm.mnemonicCodeUpdateStr == null) {
        this.$message.warning("请选择更新范围");
        return;
      }
      if (this.mnemonicCodeForm.mnemonicCodeFormatFlag === '' || this.mnemonicCodeForm.mnemonicCodeFormatFlag == null) {
        this.$message.warning("请选择更新格式");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '生成中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.archives.mnemonicCodeCreate, this.mnemonicCodeForm).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '助记码生成操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功'});
        } else {
          this.$notify({
            type: "error",
            title: '助记码生成操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: data.errorMsg});
        }
      }).catch((err) => {
        this.$notify({
          type: "error",
          title: '助记码生成操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({message: '请求失败', type: 'error'});
      }).finally(() => {
        loading.close();
      });
    },
    abbreviateSubmitData() {
      if (this.abbreviateForm.abbreviateUpdateStr === '' || this.abbreviateForm.abbreviateUpdateStr == null) {
        this.$message.warning("请选择更新范围");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '生成中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.archives.abbreviateCreate, this.abbreviateForm).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '简称生成操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功'});
        } else {
          this.$notify({
            type: "error",
            title: '简称生成操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: data.errorMsg});
        }
      }).catch((err) => {
        this.$notify({
          type: "error",
          title: '简称生成操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({message: '请求失败', type: 'error'});
      }).finally(() => {
        loading.close();
      });
    }
  }
};
</script>
<style scoped>
/*.setting-form{*/
/*  height:300px;*/
/*}*/
.foot {
  text-align: center;
}

.select-number {
  width: 80px;
}
</style>




// WEBPACK FOOTER //
// src/page/archives/goods/Set.vue